import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "absolute" }
const _hoisted_4 = { class: "h-10 flex flex-col justify-center" }
const _hoisted_5 = { class: "absolute" }
const _hoisted_6 = { class: "h-10 flex items-center pl-2" }
const _hoisted_7 = ["onKeyup"]

import { XIcon } from '@heroicons/vue/outline';
import { SearchIcon } from '@heroicons/vue/solid';
import { ref, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();
const searchText: Ref<string> = ref(route.query.q as string);

const onSubmit = async () => {
  if (searchText.value === '') {
    // empty search, do nothing
    return;
  } else if ((route.query.q as string) === searchText.value) {
    // reload
    await store.dispatch('search/fetch', { query: searchText.value });
  } else {
    // new search
    router.push({ name: 'Search', query: { q: searchText.value } });
  }
};

const onClear = () => {
  searchText.value = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (searchText.value && searchText.value !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: "h-5 w-5 mr-2 cursor-pointer",
                  onClick: onClear
                }, [
                  _createVNode(_unref(XIcon))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: "w-5 h-5 cursor-pointer",
          onClick: onSubmit
        }, [
          _createVNode(_unref(SearchIcon))
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("input", {
      class: "border border-gray-300 rounded w-full h-10 px-10 focus:border-secondary focus:outline-none",
      id: "search",
      type: "text",
      placeholder: "Search for topics, authors, publications, ...",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
      onKeyup: _withKeys(onSubmit, ["enter"])
    }, null, 40, _hoisted_7), [
      [_vModelText, searchText.value]
    ])
  ]))
}
}

})